import { css } from '@emotion/react';

import LexicalDefaultStyles from '../default/styles';
import { createLexicalBulletListStyles, createLexicalCheckListStyles } from '../list-styles';
import { createLexicalTableStyles } from '../table-styles';

const bulletListStyles = createLexicalBulletListStyles({
  circleClass: 'MarkdownEditorTheme__ul2',
  discClass: 'MarkdownEditorTheme__ul1',
  squareClass: 'MarkdownEditorTheme__ul3',
});

const checkListStyles = createLexicalCheckListStyles({
  checkedClass: 'MarkdownEditorTheme__listItemChecked',
  uncheckedClass: 'MarkdownEditorTheme__listItemUnchecked',
});

const tableStyles = createLexicalTableStyles({
  tableClass: 'MarkdownEditorTheme__table',
  tableCellClass: 'MarkdownEditorTheme__tableCell',
  tableCellHeaderClass: 'MarkdownEditorTheme__tableCellHeader',
  borderColor: 'var(--chakra-colors-gray-300)',
  headerBackgroundColor: 'var(--chakra-colors-gray-100)',
});

export default css`
  ${LexicalDefaultStyles}
  ${tableStyles}

  .MarkdownEditorTheme {
  }

  .MarkdownEditorTheme__quote {
    margin: 0;
    margin-left: 0;
    margin-bottom: var(--chakra-space-2);
    border-left-color: inherit;
    border-left-width: 4px;
    border-left-style: solid;
    padding-left: var(--chakra-space-4);
    opacity: 0.7;
  }

  .MarkdownEditorTheme__h1 {
    font-size: var(--chakra-fontSizes-3xl);
    font-weight: 600;
    margin: var(--chakra-space-2) 0 var(--chakra-space-1);
  }
  .MarkdownEditorTheme__h2 {
    font-size: var(--chakra-fontSizes-2xl);
    font-weight: 600;
    margin: var(--chakra-space-2) 0 var(--chakra-space-1);
  }
  .MarkdownEditorTheme__h3 {
    font-size: var(--chakra-fontSizes-xl);
    font-weight: 600;
    margin: var(--chakra-space-2) 0 var(--chakra-space-1);
  }
  .MarkdownEditorTheme__h4 {
    font-size: var(--chakra-fontSizes-lg);
    font-weight: 600;
    margin: var(--chakra-space-2) 0 var(--chakra-space-1);
  }
  .MarkdownEditorTheme__h5 {
    font-size: var(--chakra-fontSizes-md);
    font-weight: 600;
    margin: var(--chakra-space-2) 0 var(--chakra-space-1);
  }

  .MarkdownEditorTheme .editor-paragraph {
    margin: var(--chakra-space-1) 0;
  }

  .MarkdownEditorTheme .editor-paragraph:first-of-type {
    margin-top: 0;
  }

  .MarkdownEditorTheme .editor-paragraph:last-of-type {
    margin-bottom: 0;
  }

  .MarkdownEditorTheme__textBold {
    font-weight: bold;
  }
  .MarkdownEditorTheme__textItalic {
    font-style: italic;
  }
  .MarkdownEditorTheme__textUnderline {
    text-decoration: underline;
  }
  .MarkdownEditorTheme__textStrikethrough {
    text-decoration: line-through;
  }
  .MarkdownEditorTheme__textUnderlineStrikethrough {
    text-decoration: underline line-through;
  }
  .MarkdownEditorTheme__textSubscript {
    font-size: 0.8em;
    vertical-align: sub !important;
  }
  .MarkdownEditorTheme__textSuperscript {
    font-size: 0.8em;
    vertical-align: super;
  }

  .MarkdownEditorTheme__code {
    font-family:
      Fira Code,
      Menlo,
      Consolas,
      Monaco,
      monospace;
    display: block;
    padding: var(--chakra-space-2) var(--chakra-space-2) var(--chakra-space-2) var(--chakra-space-4);
    margin: 0;
    margin-top: var(--chakra-space-2);
    margin-bottom: var(--chakra-space-2);
    overflow-x: auto;
    position: relative;
    tab-size: 2;
    background: var(--chakra-colors-chakra-subtle-bg);
  }

  .MarkdownEditorTheme__link {
    text-decoration: underline;
    cursor: pointer;
    opacity: 0.8;
  }

  .MarkdownEditorTheme__ol1 {
    padding: 0;
    margin: 0;
    list-style-position: outside;
  }
  .MarkdownEditorTheme__ol2 {
    padding: 0;
    margin: 0;
    list-style-type: upper-alpha;
    list-style-position: outside;
  }
  .MarkdownEditorTheme__ol3 {
    padding: 0;
    margin: 0;
    list-style-type: lower-alpha;
    list-style-position: outside;
  }
  .MarkdownEditorTheme__ol4 {
    padding: 0;
    margin: 0;
    list-style-type: upper-roman;
    list-style-position: outside;
  }
  .MarkdownEditorTheme__ol5 {
    padding: 0;
    margin: 0;
    list-style-type: lower-roman;
    list-style-position: outside;
  }
  .MarkdownEditorTheme__ul {
    padding: 0;
    margin: 0;
    list-style-position: outside;
  }

  ${bulletListStyles}

  .MarkdownEditorTheme__listItem {
    margin: 0 var(--ck-spacing-8);
  }
  .MarkdownEditorTheme__nestedListItem {
    list-style-type: none;
  }
  .MarkdownEditorTheme__nestedListItem:before,
  .MarkdownEditorTheme__nestedListItem:after {
    display: none;
  }

  ${checkListStyles}

  .chakra-ui-dark .MarkdownEditorTheme__tableCell {
    border-color: var(--chakra-colors-gray-600);
  }

  .chakra-ui-dark .MarkdownEditorTheme__tableCellHeader {
    background-color: var(--chakra-colors-gray-700);
  }
`;
